import { useParams } from 'react-router-dom';
import { parseLatitudeValue, parseLongitudeValue } from 'shared/utils';

// Index signature lets a Route's match.params (whose keys TS can't infer from a
// comma-delimited path) be passed in alongside a typed useParams() result.
type MapUrlParams = {
  lat?: string;
  lng?: string;
  zoom?: string;
  [key: string]: string | undefined;
};

type ParsedMapUrlParams =
  | {
      latitudeParam: number;
      longitudeParam: number;
      zoomLevelParam?: number;
    }
  | Record<string, never>;

// Accepts params from either useParams() or a Route's match.params so the same
// parsing runs in and out of a React component.
export const parseLatLngFromUrl = (
  params: MapUrlParams,
): ParsedMapUrlParams => {
  const { lat, lng, zoom } = params;

  const parsedLatitude = parseLatitudeValue(lat);
  const parsedLongitude = parseLongitudeValue(lng);
  const parsedZoomLevel = Number(zoom?.toLowerCase().replace('z', ''));

  if (!parsedLatitude || !parsedLongitude) {
    return {};
  }

  if (Number.isNaN(parsedZoomLevel)) {
    return {
      latitudeParam: parsedLatitude,
      longitudeParam: parsedLongitude,
    };
  }

  return {
    latitudeParam: parsedLatitude,
    longitudeParam: parsedLongitude,
    zoomLevelParam: parsedZoomLevel,
  };
};

export const useLatLngFromUrl = (): ParsedMapUrlParams => {
  // Routes.tsx -> <Route path="/@:lat,:lng,:zoom?"... />
  const params = useParams<{ lat: string; lng: string; zoom?: string }>();
  return parseLatLngFromUrl(params);
};
